import "./App.css";
import { MainLayout } from "./components/MainLayout";
import { ReactNotifications } from "react-notifications-component";
import { Protected } from "./auth/Protected";

function App() {
  return (
    <Protected>
      <div className="App">
        <ReactNotifications />
        <MainLayout />
      </div>
    </Protected>
  );
}

export default App;
